<template>
  <div>
    <Header :items="navigation_lables" :parentHandler="handleNavigation" />
    <div class="flex">
      <div class="w-0 md:w-1/6 md:visible invisible bg-gray-800">
        <sidebar
          title="Navigation"
          :items="navigation_lables"
          :parentHandler="handleNavigation"
        />
      </div>
      <div class="xl:w-4/5 w-full bg-gray-700 mx-auto">
        <div v-for="i in navigation_lables" :key="i.id">
          <div v-if="i.replace(/\s/g, '') == selected">
            <component v-bind:is="selected"> </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar';
import Header from './Header';
import ManageRequests from './ManageRequests';
import ManageOptionRules from './ManageOptionRules';
import ManageLeaders from './ManageLeaders';
import ManageLDAPOverrides from './ManageLDAPOverrides';
import RequestHistory from './RequestHistory';
import CSV from './CSV';
import EnableSelection from './EnableSelection';
import ManageModules from './ManageModules';
import ManageOfficeMembers from './ManageOfficeMembers.vue';
import ProcessRequests from './ProcessRequests';
import ApproveRequests from './ApproveRequests';

export default {
  components: {
    Header,
    Sidebar,
    ProcessRequests,
    ApproveRequests,
    ManageRequests,
    ManageOptionRules,
    ManageLeaders,
    ManageLDAPOverrides,
    RequestHistory,
    CSV,
    EnableSelection,
    ManageModules,
    ManageOfficeMembers,
  },
  data: () => ({
    navigation_lables: [
      'Process Requests',
      'Manage Modules',
      'Manage Option Rules',
      'Manage Leaders',
      'Manage LDAP Overrides',
      'Request History',
      'CSV',
      'Enable Selection',
      'Manage Office Members',
    ],
    selected: '',
  }),
  created() {
    const isAdmin = localStorage.getItem('admin');
    if (isAdmin == 1) {
      this.navigation_lables = [
        'Approve Requests',
        'Process Requests',
        'Manage Modules',
        'Manage Option Rules',
        'Manage Leaders',
        'Manage LDAP Overrides',
        'Request History',
        'CSV',
        'Enable Selection',
        'Manage Office Members',
      ];
    }
  },
  methods: {
    /**
     * Replace selected with the name of the selected
     *  navigation item without spaces
     * @param {String} link
     */
    handleNavigation(link) {
      this.selected = link.replace(/\s/g, '');
      console.log(this.selected.replace(/\s/g, ''));
    },
  },
};
</script>
